import { Icon } from "react-migration/components/Icon";
import { LoadingIndicator } from "./LoadingIndicator";
import { clsx } from "clsx";

type EmptyStateContentProps = {
  type: "searching" | "no-results";
};

export function EmptyStateContent({ type }: Readonly<EmptyStateContentProps>) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 w-full h-full text-text-base-tertiary text-xs">
      {type === "searching" ? (
        <LoadingIndicator show={true} size="lg" />
      ) : (
        <Icon
          icon="icon-lt-search-line"
          size="xl"
          extraClasses="flex items-center justify-center text-text-base-tertiary"
        />
      )}
      <span
        className={clsx(
          "text-base font-medium",
          type === "no-results" ? "text-text-base-primary" : "text-text-base-tertiary"
        )}
      >
        {type === "no-results" ? "No results found" : "Searching..."}
      </span>
      {type === "no-results" && (
        <span className="text-sm text-text-base-tertiary">Try searching with different keywords</span>
      )}
    </div>
  );
}
